/**
 * Created on 2017/2/21. 过滤器
 */
define('filters/appmng/appmange-appsrfs.filter',['app', 'mainCons'], function (app, mainCons) {

    // 各种产品对应的菜单路由
    var prodTypeFilterMap = mainCons.appConstant.prodTypeFilter;

    app.filter('appsrfs',['$filter', function ($filter) {
        return function (pro) {
            if(pro.prodType == 19){ //免安装应用-h5默认跳应用详情页面  rpk是rpk管理页面
                //1.RPK  2.H5
                if(pro.freeInstallType == 2){
                    return 'freeInstall.detail'+ '({prodID:' + pro.prodID + '})';
                }else{
                    return 'freeInstall.pkg'+ '({prodID:' + pro.prodID + '})';
                }
            }else{
                return $filter('auiMapWithDefault')(pro.prodType, prodTypeFilterMap)+ '({prodID:' + pro.prodID + '})';
            }
        }
    }])
});
